export default __webpack_public_path__ + "static/media/send.119326c1.svg";